import React from 'react';
import { useHistory, Route} from 'react-router-dom';
import {connect} from 'react-redux';
import { Button, message, Result, Spin } from 'antd';


const AuthenticatedRoute = ({ currentUser, fetchingUserStatus, isAuthenticated, ...props}) => {

    let history = useHistory();

    if(fetchingUserStatus === "SUCCESS" && isAuthenticated && currentUser) {
        return <Route {...props} />
    } else if(fetchingUserStatus === "FAILED"){
        
        return  <div className="centered-content">
                    <Result
                        status="403"
                        title="403"
                        subTitle="You must be signed in to access this page"
                        extra={[
                            <Button className='login-btn' type='primary'>
                                <a href='https://www.api.cubits.ai/accounts/signup/'>
                                Sign Up
                                </a>
                            </Button>,
                            <Button className='login-btn' ghost>
                                <a href='https://www.api.cubits.ai/accounts/login/'>
                                Login
                                </a>
                            </Button>
                        ]}
                    />
                </div>
    } else {
        return <div className="loading-authentication">
                    <Spin />
                </div>
    }
}

const mapStateToProps = (state) => {
    return {
        fetchingUserStatus: state.userReducer.fetchingUserStatus,
        isAuthenticated: state.userReducer.isAuthenticated,
        currentUser: state.userReducer.user
    }
}
export default connect(mapStateToProps, {})(AuthenticatedRoute);